import { useState } from "react";
import StatsTabs from "../../model/statsTab";
import { handleTabChangeValue, setRank } from "../providers/statsTab";

export function useStatsTab(): [StatsTabs, Function, Function] {
    const [state, setState] = useState({
        value: 0,
        allTimeBestRank: "loading",
        rank: "loading",
        thisWeekBestRank: "loading",
    });

    return [state,
        (value: number) => handleTabChangeValue(setState, value),
        (field: string, value: string) => setRank(setState, field, value),
    ];
}
